import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  TextField,
} from "@material-ui/core";
import React from "react";
import { getTranslation } from "../../heplers/translationHelper";
import LocaleNumberField from "../../components/LocaleNumberField";
import { useState, useEffect } from "react";
import { Checkbox } from "@material-ui/core";
import {
  Post_EnableAutoIndexation_URL,
  Get_EnableAutoIndexation_URL,
} from "../../constants/apiUrls";
import ButtonWithLoading from "../../components/ButtonWithLoading";
import { Post, Get } from "../../actions";
import { useSnackbar } from "notistack";

export const IndexationReminderSettings = () => {
  const [indexationReminderCheck, setIndexationReminderCheck] = useState();
  const [indexationPercentage, setIndexationPercentage] = useState();
  const [isLoading, setIsLoading] = useState(false);
  // const [indexationData, setIndexationData] = useState();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    autoIndexationData();
  }, []);

  const autoIndexationData = () => {
    Get(
      {},
      Get_EnableAutoIndexation_URL,
      null,
      (res) => {
        setIndexationPercentage(res?.data?.indexationPercentage);
        setIndexationReminderCheck(res?.data?.enableAutoIndexation);
      },
      (err) => {
        enqueueSnackbar(
          err
            ? err.data
            : "An error occurred while processing your request. Please contact with admin",
          { variant: "error" }
        );
      }
    );
  };

  const enableAutoIndexation = () => {
    setIsLoading(true);
    Post(
      {
        enable: indexationReminderCheck,
        indexationPercentage: indexationPercentage,
      },
      Post_EnableAutoIndexation_URL,
      null,
      (res) => {
        enqueueSnackbar(res ? res.data : "Data saved successfully", {
          variant: "success",
        });
        setIsLoading(false);
      },
      (err) => {
        enqueueSnackbar(
          err
            ? err.data
            : "An error occurred while processing your request. Please contact with admin."
        );
        setIsLoading(false);
      }
    );
  };
  return (
    <>
      <FormControl style={{ marginBottom: "15px" }}>
        <FormControlLabel
          label={getTranslation(
            "Indexation Settings",
            "Indexation Settings",
            "Indexation Settings"
          )}
          labelPlacement="start"
          control={
            <Checkbox
              checked={
                indexationReminderCheck ? indexationReminderCheck : false
              }
              id="indexationReminderCheck"
              style={{
                color: "rgb(229,60,22)",
              }}
              onChange={(e, check) => {
                setIndexationReminderCheck(check);
              }}
            />
          }
        />
      </FormControl>
      <br />
      <LocaleNumberField
        fullWidth
        required={false}
        variant="outlined"
        id="indexationPercentage"
        label={getTranslation(
          "Indexation Percentage",
          "Indexation Percentage",
          "Indexation Percentage"
        )}
        name="indexationPercentage"
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        style={{ width: "30%" }}
        onChange={(e) => {
          setIndexationPercentage(e.target.value);
        }}
        value={indexationPercentage}
      />
      <div
        style={{ display: "flex", justifyContent: "center", marginTop: "16px" }}
      >
        <ButtonWithLoading
          title={getTranslation("Save", "Save", "Save")}
          loading={isLoading}
          style={{
            backgroundColor: "rgb(229,60,22)",
            color: "white",
            fontWeight: "bold",
          }}
          variant="contained"
          onClick={enableAutoIndexation}
        />
      </div>
    </>
  );
};
